import { render } from "./EmployeeSidebar.vue?vue&type=template&id=35d07dcc&scoped=true"
import script from "./EmployeeSidebar.vue?vue&type=script&lang=js"
export * from "./EmployeeSidebar.vue?vue&type=script&lang=js"

import "./EmployeeSidebar.vue?vue&type=style&index=0&id=35d07dcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d07dcc"]])

export default __exports__